<template>
    <div id="nova" data-test="test" :data-user-role="userRole ? userRole : null">
        <MainHeader class="fixed z-50 left-0 right-0"/>

        <!-- Content -->
        <div dusk="content" class="lg:relative pt-[54px]">
            <div
                v-if="!isMainMenuHidden"
                class="hidden bg-[#1E246E] dark:bg-transparent lg:block lg:fixed lg:overflow-y-auto top-[54px] left-0 bottom-0 lg:bottom-auto w-60 px-3 pt-8 pb-12 h-full !min-h-screen scrollbar-light dark:scrollbar-dark"
            >
                <!-- The Main Menu on desktop gets extra padding to keep the bottom of the sidebar from feeling crowded -->
                <MainMenu class="pb-8" data-screen="desktop" />
            </div>

            <div
                :class="isMainMenuHidden ? '' : 'lg:ml-60'"
                class="p-4 md:py-8 md:px-12 space-y-8"
                id="app-layout"
            >
                <Breadcrumbs v-if="breadcrumbsEnabled" />

                <FadeTransition>
                    <slot />
                </FadeTransition>

<!--                <Footer />-->
            </div>
        </div>
    </div>
</template>



<script>
import MainHeader from '@/layouts/MainHeader'
import Footer from '@/layouts/Footer'
import {mapGetters} from 'vuex'

export default {
    components: {
        MainHeader,
        Footer,
    },

    mounted() {
        Nova.$on('error', this.handleError)
        Nova.$on('token-expired', this.handleTokenExpired)
    },

    beforeUnmount() {
        Nova.$off('error', this.handleError)
        Nova.$off('token-expired', this.handleTokenExpired)
    },

    methods: {
        handleError(message) {
            Nova.error(message)
        },

        handleTokenExpired() {
            // @TODO require Nova._createToast() to support action with link.
            Nova.$toasted.show(this.__('Sorry, your session has expired.'), {
                action: {
                    onClick: () => Nova.redirectToLogin(),
                    text: this.__('Reload'),
                },
                duration: null,
                type: 'error',
            })

            setTimeout(() => {
                Nova.redirectToLogin()
            }, 5000)
        },
    },

    computed: {
        ...mapGetters('store/customStore', ['isMainMenuHidden']),
        ...mapGetters(['currentUser']),
        userRole() {
            return this.currentUser?.roles.map((role) => role.name);
        },
        breadcrumbsEnabled(){
            return Nova.config('breadcrumbsEnabled')
        }
    },
}
</script>
